import { render } from "./UpdateAvatarPopup.vue?vue&type=template&id=2651c4bc&scoped=true&ts=true"
import script from "./UpdateAvatarPopup.vue?vue&type=script&lang=ts"
export * from "./UpdateAvatarPopup.vue?vue&type=script&lang=ts"

import "./UpdateAvatarPopup.vue?vue&type=style&index=0&id=2651c4bc&lang=scss&scoped=true"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2651c4bc"]])

export default __exports__